import { useField } from "formik";
import QuestionWithTemplate from "./QuestionWithTemplate";
import QuestionDate from "./QuestionDate";
import { memo, useMemo } from "react";
import Question from "./Question";
import QuestionWithRadio from "./QuestionWithRadio";
import QuestionWithDD from "./QuestionWithDD";
import { Col, Row } from "react-bootstrap";
import { ASSESSMENT_REPORT_V2_QUESTIONS, CHATTER_CONSULTATION_REPORT_V2_QUESTIONS, CLASSROOM_REPORT_V2_QUESTIONS, CONSULTATION_REPORT_V2_QUESTIONS, INDIVIDUAL_SESSION_REPORT_V2_QUESTIONS, TREATMENT_SUMMARY_REPORT_V2_QUESTIONS } from "config/constants";
import QuestionRecommendation from "./QuestionRecommendation";
import QuestionLocation from "./QuestionLocation";
import QuestionDiagnosis from "./QuestionDiagnosis";
import QuestionCustomEditor from "./QuestionCustomEditor";
import QuestionMultipleRecommendation from "./QuestionMultipleRecommendation";
import QuestionMultipleObservation from "./QuestionMultipleObservation";
import { QuestionChatterProgramDescription } from "./QuestionChatterProgramDescription";
import CustomEditor from "components/TipTapEditor/CustomeEditor";
import QuestionSingleRecommendation from "./QuestionSingleRecommendation";

const RenderQuestion = memo(function RenderQuestion({ question, characterLimit, speechToText = false, recommendationCharLimit = 1500, customEditorCharLimit = 1500, caseVeteran, ...props }) {
  const [field, meta] = useField(props.fieldName);
  return (
    <>
      <div className="d-flex align-itmes-center gap-10">
        {question?.visibility !== "default" && (
          <AppInputField
            name={`${question?.id}.other_details.visibility`}
            type="checkbox"
            className="form-check"
            style={{ height: 25, width: 25 }}
          />
        )}
        {props.showQuestion !== false && (
          <h6 className="section-title w-100" style={{ marginBottom: "7px" }}>
            {!isNaN(props.questionIndex) && `${props.questionIndex}. `}
            {question?.question}
          </h6>
        )}
      </div>
      <Row className={`reports-v2-question ${question?.question_type}`}>
        {question.placeholder && (
          <Col lg="4">
            <p style={{ fontStyle: "italic", color: "#071E3E" }}>{question.placeholder}</p>
          </Col>
        )}
        <Col lg={question.placeholder ? 8 : 12} className="session-input-radio text-area-report">
          {question?.question_type === "textarea" ? (
            [
              INDIVIDUAL_SESSION_REPORT_V2_QUESTIONS.customEditor,
              CLASSROOM_REPORT_V2_QUESTIONS.classroom_information,
              ASSESSMENT_REPORT_V2_QUESTIONS.summary,
              ASSESSMENT_REPORT_V2_QUESTIONS.clinical_impressions,
              CHATTER_CONSULTATION_REPORT_V2_QUESTIONS?.clinical_summary,
              TREATMENT_SUMMARY_REPORT_V2_QUESTIONS?.diagnosis,
              TREATMENT_SUMMARY_REPORT_V2_QUESTIONS?.additionalInformation,
              TREATMENT_SUMMARY_REPORT_V2_QUESTIONS.summary,
              TREATMENT_SUMMARY_REPORT_V2_QUESTIONS.clinical_impressions
            ].includes(question.id) ? <QuestionCustomEditor speechToText={INDIVIDUAL_SESSION_REPORT_V2_QUESTIONS.customEditor == question.id} charLimit={customEditorCharLimit} question={question} {...props} {...field} /> :
              question.id === INDIVIDUAL_SESSION_REPORT_V2_QUESTIONS.observation ? <QuestionMultipleObservation question={question} {...props} {...field} />
                : question.id === CHATTER_CONSULTATION_REPORT_V2_QUESTIONS.program_description ? (
                  <QuestionChatterProgramDescription caseVeteran={caseVeteran} question={question} {...field} {...props} />) : question?.id == TREATMENT_SUMMARY_REPORT_V2_QUESTIONS?.background ? <QuestionSingleRecommendation speechToText={speechToText} charLimit={recommendationCharLimit} question={question} {...props} {...field} />
                  :
                  <Question
                    speechToText={speechToText}
                    characterLimit={characterLimit}
                    question={question}
                    {...props}
                    {...field}
                  />
          ) : question?.question_type === "textarea_radio" ? (
            question.id === INDIVIDUAL_SESSION_REPORT_V2_QUESTIONS.location ? (
              <QuestionLocation question={question} {...props} {...field} />
            ) : [
              INDIVIDUAL_SESSION_REPORT_V2_QUESTIONS.diagnosis,
              CONSULTATION_REPORT_V2_QUESTIONS.diagnosis
            ].includes(question.id) ? (
              <QuestionDiagnosis question={question} {...props} {...field} />
            ) : (
              <QuestionWithRadio question={question} {...props} {...field} />
            )
          ) : question?.question_type === "textarea_dd" ? (
            <QuestionWithDD question={question} {...props} {...field} />
          ) : question?.question_type === "template" ? (
            question.id === INDIVIDUAL_SESSION_REPORT_V2_QUESTIONS.recommendation ? (
              <QuestionRecommendation speechToText={speechToText} question={question} {...props} {...field} />
            ) : question.id === INDIVIDUAL_SESSION_REPORT_V2_QUESTIONS.multiRecommendation ? (
              <QuestionMultipleRecommendation question={question} {...props} {...field} />
            ) : (
              <QuestionWithTemplate question={question} {...props} {...field} />
            )
          ) : question?.question_type === "date" ? (
            <QuestionDate question={question} {...props} {...field} />
          ) : (<p>Unable to render question</p>)}
        </Col>
      </Row>
    </>
  );
});


export const RenderQuestionById = memo(function RenderQuestionById({ questionId, reportQuestions, ...props }) {
  console.log("questionId, reportQuestions", questionId, reportQuestions);
  const question = useMemo(() => {
    if (!questionId || !reportQuestions?.length) {
      return null;
    }

    return reportQuestions?.find((q) => q.id === questionId);
  }, []);
  if (!question) {
    return <p>Question not found!</p>;
  }

  return (
    <RenderQuestion
      question={question}
      fieldName={question?.id}
      {...props}
    />
  );
})

export default RenderQuestion;